import { gql } from '@/__generated__/gql';

export const GET_ASSET_CLASSES_QUERY = gql(`
  query AssetClasses($tenantId: String) {
    assetClasses(tenantId: $tenantId) {
      id
      name
      defaultAllocationPercentage
      illiquid
      subAssetClasses {
        id
        name
        defaultAllocationPercentage
        illiquid
      }
    }
  }
`);
